import { GET_MAP_LOCATIONS_SUCCESS } from './map.types';

const initialState = {
    mapLocations: { clients: [], staff: [] },
};

export const mapReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MAP_LOCATIONS_SUCCESS:
            return {
                ...state,
                mapLocations: action.payload,
            };

        default:
            return state;
    }
};
